export const TOGGLE__VISIBILITY__SPINNER = 'TOGGLE/VISIBILITY/SPINNER'

export const SAVE__BILLING_INFO_FORM = 'SAVE__BILLING_INFO_FORM'
